module.exports = __webpack_public_path__ + "img/thick.c9d76f17.svg";